import React from 'react';
import { Badge, Highlight } from '@mantine/core';

import { useOrganisationSearch } from '../../context/OrganisationSearchContext';
import { getFranchiseObject } from '../../constants';

type Props = {
    franchise: string;
};

function FranchiseBadge({ franchise }: Props) {
    const { organisationSearch } = useOrganisationSearch();
    const mappedFranchise = getFranchiseObject(franchise);

    return (
        <Badge variant="light" size="xs" color={mappedFranchise.color}>
            <Highlight
                size="xs"
                className="font-semibold"
                highlight={organisationSearch}
            >
                {mappedFranchise.label ?? ''}
            </Highlight>
        </Badge>
    );
}

export default FranchiseBadge;
